<script setup lang="ts" generic="T extends {from_date?:Date|null, to_date?:Date|null}">
import Filter from "../icons/Filter.vue";

const options = defineModel<T>();
</script>

<template>
  <FrontPrimaryCard :icon="Filter" title="Filtra per data">
    <div class="mb-3">
      <FormField name="filter_date_from" v-slot="{ componentField }">
        <FormItem>
          <FormLabel>Dal</FormLabel>
          <DatePicker v-bind="componentField" v-model="options.from_date" :has-input="false"></DatePicker>
        </FormItem>
      </FormField>
    </div>
    <div>
      <FormField name="filter_date_to" v-slot="{ componentField }">
        <FormItem>
          <FormLabel>Al</FormLabel>
          <DatePicker v-bind="componentField" v-model="options.to_date" :has-input="false"></DatePicker>
        </FormItem>
      </FormField>
    </div>
  </FrontPrimaryCard>
</template>
